(function () {
  var PROTECTION_HANDLE = 'protezione-di-consegna';
  var MAX_RECS = 5;
  var lastKey = '';

  function money(cents) { return '£' + (Number(cents) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function syncTotals() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var slot = drawer.querySelector('[data-rv-tiers-slot]');
    var products = drawer.querySelector('[data-products]');
    var fresh = products ? products.querySelector('.rv-tiers') : null;
    if (slot) {
      if (fresh) { slot.innerHTML = ''; slot.appendChild(fresh); }
      else if (products && !products.querySelector('.cart__item')) { slot.innerHTML = ''; }
    }
    var tiers = slot ? slot.querySelector('.rv-tiers') : drawer.querySelector('.rv-tiers');
    var was = drawer.querySelector('[data-rv-cmp-total]');
    if (was) {
      var cmp = tiers ? Number(tiers.getAttribute('data-rv-cmp')) : 0;
      var total = tiers ? Number(tiers.getAttribute('data-rv-total')) : 0;
      was.textContent = cmp > total ? money(cmp) : '';
    }
    var count = drawer.querySelector('[data-rv-count]');
    if (count && tiers) count.textContent = tiers.getAttribute('data-rv-qty');
  }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function rebuildDrawer() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
  }

  function renderRecs(products, box) {
    var track = box.querySelector('[data-rv-track]');
    var dots = box.querySelector('[data-rv-dots]');
    track.innerHTML = products.map(function (p) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var multi = p.variants.length > 1;
      var opts = multi ? p.variants.map(function (x) {
        return '<option value="' + x.id + '" data-price="' + x.price + '" data-cmp="' + (x.compare_at_price || 0) + '"' + (x.available ? '' : ' disabled') + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + (x.available ? '' : ' – sold out') + '</option>';
      }).join('') : '';
      var label = multi ? (p.options && p.options.length === 1 ? (p.options[0].name || p.options[0]) : 'Options') : '';
      return '<div class="rv-rec">' +
        '<a href="' + esc(p.url) + '"><img class="rv-rec__img" loading="lazy" alt="' + esc(p.title) + '" src="' + esc(img(p.featured_image, 240)) + '"></a>' +
        '<div class="rv-rec__info">' +
          '<a class="rv-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="rv-rec__price" data-rv-price></div>' +
          (multi ? '<div class="rv-rec__label">' + esc(label) + '</div><select class="rv-rec__select" data-rv-variant>' + opts + '</select>' : '<input type="hidden" data-rv-variant value="' + v.id + '" data-price="' + v.price + '" data-cmp="' + (v.compare_at_price || 0) + '">') +
          '<button type="button" class="rv-rec__add" data-rv-add>+ Add</button>' +
        '</div></div>';
    }).join('');
    dots.innerHTML = products.length > 1 ? products.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>'; }).join('') : '';
    box.querySelector('.rv-recs__arrows').style.display = products.length > 1 ? '' : 'none';
    track.querySelectorAll('.rv-rec').forEach(updatePrice);
    track.scrollLeft = 0;
    box.hidden = products.length === 0;
  }

  function updatePrice(card) {
    var sel = card.querySelector('[data-rv-variant]');
    var src = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
    var price = Number(src.getAttribute('data-price'));
    var cmp = Number(src.getAttribute('data-cmp'));
    var out = cmp > price
      ? '<span class="rv-ci__now">' + money(price) + '</span><s class="rv-ci__was">' + money(cmp) + '</s>'
      : '<span class="rv-ci__plain">' + money(price) + '</span>';
    card.querySelector('[data-rv-price]').innerHTML = out;
    var btn = card.querySelector('[data-rv-add]');
    var unavailable = sel.tagName === 'SELECT' && src.disabled;
    btn.disabled = unavailable;
    btn.textContent = unavailable ? 'Sold out' : '+ Add';
  }

  function loadRecs(cart) {
    var box = document.getElementById('RvCartRecs');
    if (!box) return;
    var items = (cart.items || []).filter(function (i) { return i.handle !== PROTECTION_HANDLE; });
    if (!items.length) { box.hidden = true; lastKey = ''; return; }
    var inCart = {};
    items.forEach(function (i) { inCart[i.product_id] = true; });
    var key = items[0].product_id + '|' + Object.keys(inCart).sort().join(',');
    if (key === lastKey) return;
    lastKey = key;
    fetch('/recommendations/products.json?product_id=' + items[0].product_id + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data.products || []).filter(function (p) {
          return !inCart[p.id] && p.handle !== PROTECTION_HANDLE && p.available;
        }).slice(0, MAX_RECS);
        renderRecs(list, box);
      })
      .catch(function () { box.hidden = true; });
  }

  function fixProtection(cart) {
    // Delivery Protection should never be in the cart more than once.
    var p = (cart.items || []).filter(function (i) { return i.handle === PROTECTION_HANDLE; })[0];
    if (p && p.quantity > 1) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: p.key, quantity: 1 })
      }).then(function () { rebuildDrawer(); }).catch(function () {});
    }
  }

  function refresh() {
    syncTotals();
    getCart().then(function (cart) { fixProtection(cart); loadRecs(cart); }).catch(function () {});
  }

  var timer;
  function scheduleRefresh() { clearTimeout(timer); timer = setTimeout(refresh, 120); }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var products = drawer.querySelector('[data-products]');
    if (products) new MutationObserver(scheduleRefresh).observe(products, { childList: true, subtree: true });
    var sub = drawer.querySelector('[data-subtotal]');
    if (sub) new MutationObserver(function () { setTimeout(syncTotals, 50); }).observe(sub, { childList: true, characterData: true, subtree: true });
    document.addEventListener('cart:updated', scheduleRefresh);

    var box = document.getElementById('RvCartRecs');
    var track = box.querySelector('[data-rv-track]');
    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-rv-variant]')) updatePrice(e.target.closest('.rv-rec'));
    });
    box.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-rv-prev]'), next = e.target.closest('[data-rv-next]');
      if (prev || next) { track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); return; }
      var add = e.target.closest('[data-rv-add]');
      if (!add || add.disabled) return;
      var card = add.closest('.rv-rec');
      var id = Number(card.querySelector('[data-rv-variant]').value);
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { lastKey = ''; rebuildDrawer(); })
        .catch(function () { add.disabled = false; add.textContent = '+ Add'; });
    });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      box.querySelectorAll('[data-rv-dots] span').forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });

    scheduleRefresh();
  });
})();
